import React, { memo, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ScaleLoader } from "react-spinners";
import { BiMessage } from "react-icons/bi";
import { AppDispatch } from "../../../store";
import { SelectAdmin } from "../../../store/slice/admin";
import { getNotifications } from "../../../store/service/adminApi";
import DashboardLayout from "../../../Layout/DashBoardLayout";
import Pagination from "../../../components/Pagination";
import { replaceSpecialCharsWithSpace } from "../../../Utils/functions";

export default function AdminsNotifications() {
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();
  const { notification, loading, pagination } = useSelector(SelectAdmin);

  const FetchNotification = async (params: { page: number } | null) => {
    try {
      await dispatch(getNotifications(params));
    } catch (error) {
      console.log(error);
    }
  };

  const sendRequest = (val: number) => {
    return FetchNotification({ page: val });
  };

  useEffect(() => {
    FetchNotification(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return (
    <DashboardLayout>
      <div className=" relative  min-w-0 break-words w-full  ">
        <p className=" text-[20px] md:text-[25px] font-[700] ">
          All Notifications
        </p>
        <div className=" block pt-10 w-full dash_webkit overflow-x-auto ">
          <table className=" bg-red-00 w-full md:w-full ">
            <tbody className="divide-y divide-[#d7d7d7]">
              {!loading &&
                notification.length !== 0 &&
                notification?.map((notification) => (
                  <TableRow
                    key={notification?.id}
                    title={notification?.fullname}
                    message={notification?.fullMessage}
                    date={notification?.time}
                  />
                ))}

              {!loading && notification.length === 0 && (
                <tr>
                  <td className="py-0 text-center " colSpan={3}>
                    <div className="w-full py-10 font-bold bg-main text-white text-sm md:text-[20px] flex justify-center items-center ">
                      You Don't Have Any Notifications Yet
                    </div>
                  </td>
                </tr>
              )}

              {loading && (
                <tr>
                  <td className="py-6 text-center " colSpan={5}>
                    <div className="w-full py-1 bg-red-00 flex justify-center items-center ">
                      <ScaleLoader />
                    </div>
                  </td>
                </tr>
              )}

              <tr>
                <td className="pt-6" colSpan={5}>
                  <Pagination
                    currentPage={pagination?.current}
                    totalPages={pagination?.total}
                    sendRequest={sendRequest}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </DashboardLayout>
  );
}

const TableRow = memo(({ title, message, date }: any) => {
  return (
    <tr className={`text-left border-b-2   border-[#d7d7d7]`}>
      <td>
        <p className=" text-center rounded-full ">
          <BiMessage />
        </p>
      </td>
      <td className="py-5 whitespace-nowra px-6 md:px-3">
        <p className=" py-1 font-bold  uppercase ">
          {replaceSpecialCharsWithSpace(title)}
        </p>
        <p className=" lowercase  ">{replaceSpecialCharsWithSpace(message)}</p>
      </td>

      <td className="py-5 whitespace-nowrap px-3">{date}</td>
    </tr>
  );
});
